import { parse } from "papaparse";

export const fileRead = async (file: File) => {
  const csv = await file.text();
  return parse(csv).data;
};
